import { useDispatch, useSelector } from "react-redux";
import styles from "./NewSectionModal.module.scss";
import Button from "../../../../../../common/components/xepp/button/Button";
import { toast } from "react-toastify";
import { addNewSection, renameSection, resetState } from "../../../../../../stores/slices/service-type-slice";
import { addNewSectionToStepAdditionalServiceRequest, renameSectionInStepAdditionalServiceRequest } from "../../../../../../stores/slices/workflow-slice";
import { useState } from "react";
import { SectionDefinition } from "../../../../../../model/service-request/section-definition";

type Props = {
  onModalClose: () => void
  section?: SectionDefinition;
  stepId?: string;
}

const NewSectionModal = (props: Props) => {
  const dispatch = useDispatch();

  const [newSectionName, SetNewSectionName] = useState(props.section?.name);

  const onSaveClick = () => {
    if (newSectionName) {
      if (props.stepId) {
        if (props.section) {
          dispatch(renameSectionInStepAdditionalServiceRequest({ stepId: props.stepId, section: props.section, newName: newSectionName }));
        } else {
          dispatch(addNewSectionToStepAdditionalServiceRequest({ stepId: props.stepId, sectionName: newSectionName }));
        }
      } else {
        if (props.section) {
          dispatch(renameSection({ section: props.section, newName: newSectionName }));
        }
        else {
          dispatch(addNewSection(newSectionName));
        }
      }
      props.onModalClose();
    } else {
      toast.warning("Fill Section Name");
    }
  }

  return (
    <div className={styles.modalOverlay} onClick={() => {}}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.headerWrapper}>
          <div className={styles.titleDiv}>
            <span className={styles.title}>Section Name</span>
            <span className={styles.subTitle}>Give this new section a name</span>
          </div>
          <button className={styles.closeBtn} onClick={() => props.onModalClose()}>
            ×
          </button>
        </div>
        <div className={styles.bodyContainer}>
          <input type="text" placeholder="Enter Name" value={newSectionName} onChange={(e) => {
            SetNewSectionName(e.target.value);
          }} />
        </div>
        <div className={styles.footerWrapper}>
          <Button
            text={'Cancel'}
            onClick={props.onModalClose}
            variant={'outline'}
          />
          <Button
            text={'Save'}
            onClick={onSaveClick}
            variant={'secondary'}
          />
        </div>
      </div>
    </div>
  );
};

export default NewSectionModal;
